import { gql, TypedDocumentNode } from "@apollo/client";

import {
  Policy,
  QuerySearchSpacePoliciesArgs,
  QuerySearchSpacePoliciesSuggestionsArgs,
  SearchSpacePoliciesOutput,
  SearchSuggestionsOutput,
  Space,
  SpacePolicyConnection,
} from "types/generated";

type SpaceDetailsPolicyNode = Pick<
  Policy,
  "id" | "name" | "description" | "type" | "body"
> & {
  spaceDetails: Pick<Space, "id" | "name">;
};

type SpaceDetailsPolicyEdge = Pick<SpacePolicyConnection, "cursor" | "inherited"> & {
  node: SpaceDetailsPolicyNode;
};

type SearchSpacePoliciesData = {
  searchSpacePolicies: {
    edges: Array<SpaceDetailsPolicyEdge>;
    pageInfo: SearchSpacePoliciesOutput["pageInfo"];
  };
};

export const SEARCH_SPACE_POLICIES: TypedDocumentNode<
  SearchSpacePoliciesData,
  QuerySearchSpacePoliciesArgs
> = gql`
  query SearchSpacePolicies($space: ID!, $input: SearchInput!) {
    searchSpacePolicies(space: $space, input: $input) {
      edges {
        cursor
        inherited
        node {
          id
          name
          description
          type
          body
          spaceDetails {
            id
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`;

type SearchSpacePoliciesCountData = {
  searchSpacePoliciesSuggestions: {
    filteredCount: SearchSuggestionsOutput["filteredCount"];
  };
};

export const SEARCH_SPACE_POLICIES_COUNT: TypedDocumentNode<
  SearchSpacePoliciesCountData,
  QuerySearchSpacePoliciesSuggestionsArgs
> = gql`
  query SearchSpacePoliciesCount($space: ID!, $input: SearchSuggestionsInput!) {
    searchSpacePoliciesSuggestions(space: $space, input: $input) {
      filteredCount
    }
  }
`;
